module.exports = __webpack_public_path__ + "img/title-prestadores.8f48ea32.svg";